import React from 'react';
import { useTranslation } from 'react-i18next';
import { getB2bBennyCaseCopy } from './b2bBennyCaseCopy';
import ocpiFigure from './benny-case-ocpi.jpg';
import styles from './B2bSolarCase.module.css';

const SITE_HREF = 'https://220-km.com/';
const EV_BOOST_HREF = 'https://www.evboost.com.ua/';
const EVA_HREF = 'https://evachargers.com/';
const EV_UA_HREF = 'https://evua.site/';

export default function B2bBennyCase() {
  const { i18n } = useTranslation();
  const copy = getB2bBennyCaseCopy(i18n.resolvedLanguage || i18n.language);

  return (
    <article className={styles.case}>
      <img className={styles.figure} src={ocpiFigure} alt={copy.figureAlt} />
      <p className={styles.stat}>{copy.stat}</p>
      <p className={styles.statCaption}>{copy.statCaption}</p>
      <h3 className={styles.headline}>{copy.headline}</h3>
      <p className={styles.body}>
        {copy.introBefore}
        <a href={SITE_HREF} target="_blank" rel="noopener noreferrer" className={styles.emsLink}>
          {copy.siteName}
        </a>
        {copy.introMid}
        <a href={EVA_HREF} target="_blank" rel="noopener noreferrer" className={styles.emsLink}>
          {copy.evaName}
        </a>
        {copy.introComma}
        <a href={EV_BOOST_HREF} target="_blank" rel="noopener noreferrer" className={styles.emsLink}>
          {copy.evBoostName}
        </a>
        {copy.introAnd}
        <a href={EV_UA_HREF} target="_blank" rel="noopener noreferrer" className={styles.emsLink}>
          {copy.evUaName}
        </a>
        {copy.introAfter}
      </p>
      <p className={styles.lead}>{copy.lead}</p>

      <ul className={styles.outcomes}>
        {copy.prices.map(item => (
          <li key={item.value} className={styles.outcome}>
            <span className={styles.outcomeValue}>{item.value}</span>{' '}
            {item.href ? (
              <a href={item.href} target="_blank" rel="noopener noreferrer" className={styles.emsLink}>
                {item.name}
              </a>
            ) : (
              item.name
            )}
          </li>
        ))}
      </ul>

      <section>
        <h4 className={styles.sectionTitle}>{copy.wasTitle}</h4>
        {copy.wasBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <section>
        <h4 className={styles.sectionTitle}>{copy.changedTitle}</h4>
        {copy.changedBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <section>
        <h4 className={styles.sectionTitle}>{copy.betterTitle}</h4>
        {copy.betterBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <caption className={styles.caption}>{copy.tableCaption}</caption>
          <thead>
            <tr>
              <th scope="col">{copy.colStage}</th>
              <th scope="col">{copy.colBefore}</th>
              <th scope="col">{copy.colAfter}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">{copy.rowMaps}</th>
              <td>{copy.beforeMaps}</td>
              <td>{copy.afterMaps}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ul className={styles.outcomes}>
        {copy.outcomes.map(item => (
          <li key={item.text} className={styles.outcome}>
            {item.value ? <span className={styles.outcomeValue}>{item.value}</span> : null}
            {item.value ? ' ' : null}
            {item.text}
          </li>
        ))}
      </ul>

      <div className={styles.botOnly}>
        <p className={styles.source}>{copy.source}</p>
        <ul className={styles.smmTags}>
          {copy.smmTags.map(tag => (
            <li key={tag} className={styles.smmTag}>
              {tag}
            </li>
          ))}
        </ul>
      </div>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: copy.headline,
          description: copy.source,
          keywords: copy.smmTags.join(', '),
          about: copy.smmTags.map(name => ({ '@type': 'Thing', name })),
        })}
      </script>
    </article>
  );
}
